export enum PortalTypes {
    Main = 1,
    Resource = 2,
    Client = 3,
}